import { Box, Typography } from "@mui/material";
import { IconButtonOutlined } from "../utils/IconButtonOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import { SkillDetails, UserCtx } from "../../../interfaces";
import { HandleDataLayer } from "../../../Helpers";

interface SingleVideoContainerProps {
  skillVideoDetails: SkillDetails;

  onClick?: () => void;
}

export const SingleVideoContainer = (props: SingleVideoContainerProps) => {
  let { skillVideoDetails, onClick } = props;
  const userCtx = useContext(UserContext) as UserCtx;
  const [isSaved, setIsSaved] = useState(false);
  useEffect(() => {
    if (!skillVideoDetails.skill_id) return;
    setIsSaved(userCtx.checkSkillSaved(skillVideoDetails?.skill_id));
  }, [skillVideoDetails.skill_id, userCtx]);
  const [hover] = useState(true);

  const handleSave = (e: React.MouseEvent<HTMLButtonElement>, skillId?: string) => {
    e.stopPropagation();
    if (!skillId) return;
    userCtx.toggleSavedSkill(skillId);
  };

  return (
    <Box
      onClick={onClick}
      sx={{
        margin: "0px 4px",

        maxWidth: "296px",
        maxHeight: "258px",
        minHeight: "258px",
        borderRadius: "15px",
        padding: "10px",
        "&:hover": {
          background: "#F2F2F2 0% 0% no-repeat padding-box",
        },
        position: "relative",
        cursor: "pointer",
      }}
      // onMouseEnter={() => setHover(true)}
      // onMouseLeave={() => setHover(false)}
    >
      <Box
        tabIndex={0}
        sx={{
          height: "155px",
          width: "276px",
          borderRadius: "15px",
          marginBottom: "6px",
          backgroundColor: skillVideoDetails.metadata?.videoThumbnail
            ? "#000000"
            : "#F2F2F2",
          backgroundImage: `url(${
            skillVideoDetails.metadata !== null
              ? skillVideoDetails.metadata?.videoThumbnail
              : "https://placehold.jp/CCCCCC/ffffff/276x155.png?text=%20"
          })`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Box sx={{ marginTop: "16px" }}>
        <Typography
          variant="body2"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            fontSize: "16px",
            fontWeight: "bold",
            marginBottom: "8px",
            maxWidth: "240px",
          }}>
          {skillVideoDetails.title}
        </Typography>

        {hover ? (
          <IconButtonOutlined
            sx={{
              marginLeft: "auto",
              width: "40px",
              height: "40px",
              position: "absolute",
              right: "10px",
              top: "179px",
            }}
            hover={<BookmarkIcon style={{ width: "24px", height: "24px" }} />}
            tooltipLabel={isSaved ? "Remove from saved videos" : "Save video"}
            tooltipPlacement="bottom"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              HandleDataLayer(
                "select",
                isSaved ? "unclick" : "click",
                "checkbox",
                "main content",
                skillVideoDetails.title,
                isSaved ? "Remove from saved videos" : "Save video",
                "onclick"
              );
              handleSave(e, skillVideoDetails.skill_id);
            }}>
            {isSaved ? (
              <BookmarkIcon style={{ width: "24px", height: "24px" }} />
            ) : (
              <BookmarkBorderOutlinedIcon style={{ width: "24px", height: "24px" }} />
            )}
          </IconButtonOutlined>
        ) : null}
      </Box>
    </Box>
  );
};
